import { useBuild } from "app/components/build/Show/lib/BuildContext";
import { filterSteps, useFilterStore } from "../components/Sidebar/useFilterStore";
import { useMemo } from "react";
import { useBuildStore } from "./useBuildStore";

/**
 * Get the list of step IDs that are filtered out by the current filter, excluding
 * expanded groups steps since their state is derived so there should always be a
 * matching child step.
 */
export const useFilteredStepIds = () => {
  const filterBy = useFilterStore((state) => state.filterBy);
  const expandedGroups = useBuildStore((state) => state.expandedGroupSteps);
  const { build } = useBuild();

  return useMemo(() => {
    return new Set(
      filterSteps(build.steps, filterBy, build)
        .filter((step) => !expandedGroups.has(step.uuid))
        .map((step) => step.uuid),
    );
  }, [filterBy, build.steps, expandedGroups]);
};
